goog.provide('el8.uiwidget.ButtonSet');

goog.require('el8.template.newDialogButton');

/**
 * As the name implies, this manages a set of buttons...
 * but more specifically, it is pretty much exclusively associated
 * with Forms + the buttons at the bottom of a dialog.
 *
 * Forms have special integrations with ButtonSets, because
 * most forms will have some associated buttons (e.g., save / cancel).
 *
 * The FormDialog will then borrow the buttons from the Form's ButtonSet and
 * render them at the bottom of the dialog. See, e.g., createLabResultVendor.js
 * for a super simple FormDialog with some buttons.
 *
 * Forms that aren't part of dialogs can also use the widget.
 * See, e.g., letterRouting.js (a settings page).
 *
 * And non-form dialogs ("NewDialogs") can have buttons (but
 * aren't assumed to, because often they will just display info
 * and use an X in the upper right to dismiss). See, e.g., fileReportsPrompt.js.
 *
 */

/**
 * A set of buttons
 *
 * @constructor
 */
el8.uiwidget.ButtonSet = function() {

    this._eventsBound = false;
    this._enabled = true;
    this._buttonsList = [];

    /**
     * A map from name --> click handler for each button.
     * @type {Object}
     */
    this._clickMap = {};

    /**
     * Container the button set should be rendered into.
     * @type {Element}
     * @private
     */
    this._container = null;

};

/**
 * Adds a button to the button set.  Buttons will be displayed in the order they
 * are added.
 */
el8.uiwidget.ButtonSet.prototype.addButton = function(name, caption, fn,
        opt_isPrimary, opt_isSubmit, opt_isDropdown, opt_allowReadonly, opt_isDangerous) {

    this._buttonsList.push({
        name: name,
        caption: caption,
        isPrimary: (opt_isPrimary === true), // defaults to false
        isDangerous: (opt_isDangerous === true), // defaults to false
        isSubmit: (opt_isSubmit === true), // defaults to false
        isDropdown: (opt_isDropdown === true), // defaults to false
        allowReadonly: (opt_allowReadonly === true) // defaults to false
    });
    this._clickMap[name] = fn;

    return this;
};

/**
 * Basically the same as addButton, but without the insane function signature.
 */
el8.uiwidget.ButtonSet.prototype.addButtonSane = function(name, caption, fn, options) {
    var buttonOptions = options || {};

    this._buttonsList.push({
        name: name,
        caption: caption,
        isPrimary: buttonOptions.isPrimary === true,
        isDangerous: buttonOptions.isDangerous === true,
        isSubmit: buttonOptions.isSubmit === true,
        isDropdown: buttonOptions.isDropdown === true,
        allowReadonly: buttonOptions.allowReadOnly === true,
        testId: buttonOptions.testId,
    });
    this._clickMap[name] = fn;

    return this;
};

/**
 * Inserts button at specific index. Useful if a form has had a bunch
 * of buttons added to it by shared code, but we want to add a middle button
 */
el8.uiwidget.ButtonSet.prototype.insertButton = function(index, buttonSpec, fn) {

    this._buttonsList.splice(index, 0, buttonSpec);
    this._clickMap[buttonSpec.name] = fn;

    return this;
};

el8.uiwidget.ButtonSet.prototype.removeButton = function(name) {

    delete this._clickMap[name];
    for (var i=0; i<this._buttonsList.length; i++) {
        if (this._buttonsList[i].name === name) {
            this._buttonsList.splice(i, 1);
            break;
        }
    }

    return this;
};

el8.uiwidget.ButtonSet.prototype.removeButtons = function() {
    this._clickMap = {};
    this._buttonsList = [];
    return this;
};

/**
 *
 */
el8.uiwidget.ButtonSet.prototype.updateButtonCaption = function(name, newCaption) {
    $('[name="'+name+'"]', this._container).text(newCaption);
    for (var i=0; i<this._buttonsList.length; i++) {
        if (this._buttonsList[i] === name) {
            this._buttonsList[i].caption = newCaption;
            break;
        }
    }
};

el8.uiwidget.ButtonSet.prototype.bindEvents = function() {
    if (this._eventsBound) { return; }
    var that = this;
    $(this._container[0]).on('click', 'button, a', function(e) {
        e.preventDefault();
        if (that._enabled) {
            var $btn = $(this);
            var name = $btn.attr('name');
            that._clickMap[name].call(that, $btn);
        }
    });

    this._eventsBound = true;
    return this;
};

el8.uiwidget.ButtonSet.prototype.unbindEvents = function() {
    if (!this._eventsBound) { return; }
    $(this._container[0]).off('click', 'button, a');
    this._eventsBound = false;
    return this;
};

/**
 * Attaches the button set to an element, rendering it inside.
 *
 * @param {Element} container The container to render the buttons under.
 */
el8.uiwidget.ButtonSet.prototype.render = function() {

    if (this._container) {
        var html = el8.template.newDialogButton.buttons({
            buttons : this._buttonsList
        });
        this._container.html(html);
        if (el8Globals.READ_ONLY && this._enabled) {
            this.disable();
            this.enable(); // Enable only those buttons marked "allowReadonly"
        }
    }

    return this;
};


/**
 * Sets the container for the buttons
 * @param {Element} container The container to render the buttons under.
 */
el8.uiwidget.ButtonSet.prototype.setContainer = function(container) {
   this._container = container;
   return this;
};

el8.uiwidget.ButtonSet.prototype.getButtonElts = function() {
    if (this._container) {
        return $.map($('button', this._container), function(elt) {
            return $(elt);
        });
    }
    return [];
};

el8.uiwidget.ButtonSet.prototype.getTabCatcher = function() {
    return $('.tabcatcher', this._container);
};

el8.uiwidget.ButtonSet.prototype.disable = function() {
    $('button', this._container).prop('disabled', true);
    this._enabled = false;
};

el8.uiwidget.ButtonSet.prototype.enable = function() {
    this._enabled = true;
    if (el8Globals.READ_ONLY) {
        this._buttonsList.forEach(function(buttonSpec) {
            if (buttonSpec.allowReadonly) {
                $('button[name="' + buttonSpec.name + '"]', this._container).prop('disabled', false);
            }
        });
    }
    else {
        $('button', this._container).prop('disabled', false);
    }
};

el8.uiwidget.ButtonSet.prototype.disableButton = function(name) {
    $('button[name="'+name+'"]', this._container).prop('disabled', true);
};

el8.uiwidget.ButtonSet.prototype.enableButton = function(name) {
    if (el8Globals.READ_ONLY) {
        for (var i = 0; i < this._buttonsList.length; i++) {
            var buttonSpec = this._buttonsList[i];
            if (buttonSpec.name === name) {
                if (buttonSpec.allowReadonly) {
                    $('button[name="'+name+'"]', this._container).prop('disabled', false);
                }
                break;
            }
        }
    }
    else {
        $('button[name="'+name+'"]', this._container).prop('disabled', false);
    }
};

el8.uiwidget.ButtonSet.prototype.hideButton = function(name) {
    $('button[name="'+name+'"]', this._container).hide();
};

el8.uiwidget.ButtonSet.prototype.showButton = function(name) {
    $('button[name="'+name+'"]', this._container).show();
};

el8.uiwidget.ButtonSet.prototype.focusButton = function(name) {
    $('button[name="'+name+'"]', this._container).focus();
};

el8.uiwidget.ButtonSet.prototype.makeButtonPrimary = function(name) {
    $('button[name="'+name+'"]', this._container)
        .removeClass('el8SecondaryButton')
        .removeClass('el8RedButton')
        .addClass('el8PrimaryButton');
};

el8.uiwidget.ButtonSet.prototype.makeButtonSecondary = function(name) {
    $('button[name="'+name+'"]', this._container)
        .removeClass('el8PrimaryButton')
        .removeClass('el8RedButton')
        .addClass('el8SecondaryButton');
};

el8.uiwidget.ButtonSet.prototype.makeButtonDangerous = function(name) {
    $('button[name="'+name+'"]', this._container)
        .removeClass('el8PrimaryButton')
        .removeClass('el8SecondaryButton')
        .addClass('el8RedButton');
};
